import { UIComponent } from "@aptus/frontend-core";
import { AutoCompleteSelect } from "components/form/autoCompleteSelect/autoCompleteSelect";
import { AocSelectProps, useAocSelect } from "./useAocSelect";

export const AocSelect: UIComponent<AocSelectProps> = (props) => (
	<AutoCompleteSelect {...useAocSelect(props)} />
);
